import { render, staticRenderFns } from "./farm-work.vue?vue&type=template&id=981ea0b4&scoped=true"
import script from "./farm-work.vue?vue&type=script&lang=js"
export * from "./farm-work.vue?vue&type=script&lang=js"
import style0 from "./farm-work.vue?vue&type=style&index=0&id=981ea0b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981ea0b4",
  null
  
)

export default component.exports
import QTable from 'quasar/src/components/table/QTable.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTable,QBtn,QBtnDropdown,QList,QItem,QItemSection,QIcon,QSeparator,QToggle,QCard,QTh,QTd,QTooltip,QCardSection,QBtnToggle,QDialog,QCardActions});qInstall(component, 'directives', {ClosePopup,Ripple});
